import React from 'react';

const SkeletonLoader = ({ pageSize }) => {
    return (
        <div className="skeleton__grid">
            <div className="grid-item">
                <ol className="agenda__tiles">

                    {Array.from({ length: pageSize }).map((_, index) => (
                        <li key={index} className="tile-event skeleton__placeholder skeleton__animation-1">
                            <div className=""></div>
                        </li>
                    ))}
                </ol>
            </div>
        </div>
    );
};

export default SkeletonLoader;
